<template>
    <div class="row mb-3 justify-content-center">
        <div class="col-12 col-md-11 whiteBG">
            <section class="blockElement mainBanner p-4">
                <div class="inner-banner-custom row align-items-center">
                    <div class="col-12 col-md-6">
                        <div class="mamPamm-content">
                           <h2 class="mb-3">{{$t('mampam_heading')}}</h2>
                            <p>{{$t('mampam_programenable')}}<a href="#" class="green">{{$t('mampam_knowmore')}}</a></p>
                            <!-- <p>The fxview MAM/PAMM program enables investors to have their funds managed by a manager of their choice, removing the need to study or follow the markets. Investors have real time access to their trading account so they can keep an eye on all trading activity.</p> -->
                            <!-- <div class="d-flex align-items-center mt-3">
                                <a href="#" class="common_btn mr-3">Register as Manager</a>
                                <a href="#" class="common_btn darkBG">Connect to a Manager</a>
                            </div> -->
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="mamPamm text-center">
                           <img src="../../../../../static/fxView/images/Mampamm_thumb.svg" width="250" alt="MAM/PAMM">
                        </div>
                    </div>
                </div>
            </section>
            <!--Section-->
            <!-- <section class="blockElement p-4">
                <div class="row mt-4 justify-content-center">
                    <div class="col-12 col-md-6">
                        <div class="mamPamm text-center">
                           <img src="../../../../../static/fxView/images/mamPamm.svg" alt="MAM/PAMM">
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="mamPamm-content">
                           <h3 class="mb-3">What is MAM/PAMM?</h3>
                           <p>MAM stands for Multi-Account Manager, and it involves combining individual traders funds into a single managed fund, made up of investor accounts, and managed by the manager.</p>
                           <p>PAMM stands for a Percentage Allocation Management Module, and the manager invests and manages his/her own funds along with the funds of investors who choose to invest with him/her.</p>
                        </div>
                    </div>
                </div>
            </section> -->
            <section class="blockElement p-4">
                 
                <div class="row mt-3 justify-content-center">
                    <div class="col-6">
                        <div class="main-title">
                            <h3 class="mb-3">{{$t('mampam_becameinvestor')}}</h3>
                            <!-- <p>Key features that put fxview's MAM/PAMM ahead of the curve</p> -->
                        </div>
                        <div class="mamPamm-feature mb-4">
                            <ul class="listing flexible">
                                <li>
                                    <feather type="check"></feather>
                                    <p class="m-0">{{$t('mampam_clicktobecame')}}</p>
                                </li>
                                <li>
                                    <feather type="check"></feather>
                                    <p class="m-0">{{$t('mampam_uniquepamid')}}</p>
                                </li> 
                                <li>
                                    <feather type="check"></feather>
                                    <p class="m-0">{{$t('mampam_createinverstor')}}</p>
                                </li> 
                                <li>
                                    <feather type="check"></feather>
                                    <p class="m-0">{{$t('mampam_monitoracc')}}</p>
                                </li> 
                            </ul>
                            <div class=" d-flex align-items-center mt-3 buttonArea">
                                <a href="#" class="common_btn btn_xs mr-2">{{$t('mampam_connectmanager')}}</a>
                            </div>
                        </div> 
                    </div>
                    <div class="col-6">
                        <div class="main-title">
                            <h3 class="mb-3">{{$t('mampam_becomemanager')}}</h3>
                            <!-- <p>Key features that put fxview's MAM/PAMM ahead of the curve</p> -->
                        </div>
                        <div class="mamPamm-feature mb-4">
                            <ul class="listing flexible">
                                <li>
                                    <feather type="check"></feather>
                                    <p class="m-0">{{$t('mampam_clickbecomemanager')}}</p>
                                </li>
                                <!-- <li>
                                    <feather type="check"></feather>
                                    <p class="m-0">Get access to promotional tools including performance links, banners, referral links and landing pages.</p>
                                </li> 
                                <li>
                                    <feather type="check"></feather>
                                    <p class="m-0">Automate your trading, with no restrictions on your trading style and order types - manual trading, EAs, hedging, scalping, and other trading styles are all welcome.</p>
                                </li>  -->
                                <li>
                                    <feather type="check"></feather>
                                    <p class="m-0">{{$t('mampam_meetconditions')}}</p>
                                </li>
                                 <li>
                                    <feather type="check"></feather>
                                    <p class="m-0">{{$t('mampam_manageaccount')}}</p>
                                </li> 
                                
                               <!--  <li>
                                    <feather type="check"></feather>
                                    <p class="m-0">Easily download detailed monthly, quarterly and annual trade and commission reports.</p>
                                </li>  --> 
                            </ul>
                            <div class=" d-flex align-items-center mt-3 buttonArea">
                                <a href="#" class="common_btn btn_xs mr-2 darkBG">{{$t('mampam_becomeManager')}}</a>
                            </div>
                        </div> 
                    </div>
                    
                    <!-- <div class="text-center">
                        <a href="#" class="common_btn large_btn">Register Now</a>
                    </div> -->
                </div>
            </section>
        </div>
        <!-- <div class=" my-4 boxCenetrSection middleBox ">
            <div class="modalArea ">
                <div class="row w-100 justify-content-center align-items-center  no-gutters">
                    <div class="col-12 mb-3 col-md-12 position-relative">
                        <div class="customPp">
                            <button type="button" class="close d-flex align-items-center justify-content-center" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="whiteBG px-4 py-5 d-flex justify-content-center align-items-center w-100">

                            <div class="selectUniqueId w-100 text-center">
                                <h4 class="mb-3"> Please enter PAMM manager's Unique ID</h4> 
                                <div class="col-12 col-md-12 ">
                                    <div class="form-group field-wrapper">
                                        <input placeholder=" " type="text" name="Unique ID" class="float-field form-control"> 
                                        <label for="Unique" class="float-label">Unique ID</label> 
                                    </div>
                                </div> 
                                <div class="full-width submitButton d-flex justify-content-center align-items-center  mt-3 w-100">
                                    <button class="common_btn btn_xs mr-2" > Submit</button>
                                </div> 
                            </div>
                           
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" my-4 boxCenetrSection middleBox ">
            <section class="blockElement p-4 managerSection whiteBG">   
                <div class="row mt-3 justify-content-center no-gutters">
                    <div class="col-12">
                        <div class="main-title  mb-3">
                            <h3 class="mb-3">PAMM manager ID :4456566</h3>
                        </div> 
                        <ul class="d-flex amountList mb-3 justify-content-between">
                            <li>
                                <h5>Amount Following</h5>
                                <h3>$1,00,000</h3> 
                            </li>
                            <li>
                                <h5>Total Connected Investor</h5>
                                <h3>2</h3> 
                            </li>
                            <li>
                                <h5>Min. Investment </h5>
                                <h3>$250</h3> 
                            </li>
                        </ul>
                        <div class="feeStructure  mb-4">
                            <div class="d-flex justify-content-between border-bottom pb-2 mb-2 align-items-center">
                                <h3>Fee Structure</h3>
                            </div>
                            <div class="d-flex justify-content-between border-bottom pb-2 mb-2 align-items-center">
                                <h3>Profit Sharing </h3>
                                <h5>10%</h5>
                            </div>
                            <div class="d-flex justify-content-between border-bottom pb-2 mb-2 align-items-center">
                                <h3>Annual Management Fee</h3>
                                <h5>$10</h5>
                            </div>
                        </div>
                        
                        
                        <div class="full-width submitButton d-flex w-100 justify-content-between align-items-center">
                            <div class="form-group mb-0">
                                <input type="checkbox" id="conditions" value="" name="conditions">
                                <label for="conditions">I accept all terms and conditions</label>
                            </div>
                            <button class="common_btn btn_xs mr-2"> Create Investor Account</button>
                        </div> 
                    </div>
                   
                </div>
            </section>
        </div>
        <div class=" my-4 boxCenetrSection middleBox ">
            <section class="blockElement p-4 managerSection whiteBG ">   
                <div class="row mt-3 justify-content-center no-gutters">
                    <div class="col-12">
                        <div class="main-title  mb-3">
                            <h3 class="mb-3">PAMM manager ID :4456566</h3>
                        </div>

                        <ul class="d-flex amountList mb-3 justify-content-between">
                            <li>
                                <h5>Amount Following</h5>
                                <h3>$1,00,000</h3> 
                            </li>
                            <li>
                                <h5>Total Connected Investor</h5>
                                <h3>2</h3> 
                            </li>
                            <li>
                                <h5>Min. Investment </h5>
                                <h3>$250</h3> 
                            </li>
                        </ul>
                        <p class="green mb-2">Your Investor account has been successfully created.</p> 
                        <div class="feeStructure  mb-4">
                            <div class="d-flex justify-content-between border-bottom pb-2 mb-2 align-items-center">
                                <h3>Investor Id</h3>
                                <h5>xxxxxxx</h5>
                            </div>
                            <div class="d-flex justify-content-between border-bottom pb-2 mb-2 align-items-center">
                                <h3>Account Base Currency</h3>
                                <h5>USD</h5>
                            </div>
                            <div class="d-flex justify-content-between border-bottom pb-2 mb-2 align-items-center">
                                <h3>Leverage</h3>
                                <h5>100x</h5>
                            </div>
                        </div>
                        <div class=" w-100 mb-3 ">
                            <p class="mb-0 green">Please Note</p>
                            <p class="mb-0">To view your Open/close positions go to Social Trade > Mam/PAMM > Overview</p>
                        </div>
                        
                        <div class="full-width submitButton d-flex w-100 justify-content-end align-items-center">
                            <button class="common_btn btn_xs mr-2">Connect to Manager</button>
                        </div> 
                    </div>
                   
                </div>
            </section>
        </div>
        <div class=" my-4 boxCenetrSection middleBox ">
            <section class="blockElement p-4 managerSection whiteBG">   
                <div class="row mt-3 justify-content-center no-gutters">
                    <div class="col-12">
                        <div class="main-title d-flex justify-content-center align-items-center mb-3">
                            <div class="w-100 text-center">
                                <h3 class="mb-0">Become a PAMM Manager</h3>
                                <p class="mb-0">In Order to become a PAMM manager, you must fullfill two conditions mentioned below.</p>
                            </div>
                        </div>
                        <div class="row no-gutters mb-3">
                           <div class="col-12 col-md-6 pr-3">
                            <div class="card border-0 h-100 mb-0">
                                <div class="card-body p-3 clientsBox text-center">
                                    <h4 class="mb-0">Minimum 3 Clients</h4>
                                    <p class="mb-0">To become a PAMM manager atleast 3 clients are required</p> 
                                </div>
                            </div>
                                  
                           </div> 
                           <div class="col-12 col-md-6 pl-3">
                            <div class="card border-0 h-100  mb-0">
                                <div class="card-body  p-3 clientsBox text-center">
                                    <h4 class="mb-0">Minimum Deposit of $5000</h4>
                                    <p class="mb-0">Minimum deposit of $5000 in total is required in order to be classified as a PAMM manager</p> 
                                </div>
                            </div>
                                
                           </div> 
                        </div>

                        
                        
                        <div class="full-width submitButton d-flex w-100 justify-content-center align-items-center">
                            <button class="common_btn btn_xs mr-2">Submit</button>
                        </div> 
                    </div>
                   
                </div>
            </section>
        </div>
           
        <div class="col-12 col-md-12 my-4 ">
            <div class="row mt-3 justify-content-center no-gutters">
                <div class="col-12">
                    <div class="main-title d-flex justify-content-between align-items-center mb-3">
                        <h3 class="mb-0">PAMM Investor Account</h3>
                        <div class="d-flex align-items-center flex-wrap">
                            <a href="#" class="common_btn btn_xs mr-2">Connect to a Manager</a> 
                            <a href="#" class="common_btn btn_xs darkBG">Become a Manager</a>
                        </div>
                    </div>
                </div>     
            </div>
            <section class="blockElement p-4 managerSection whiteBG p-3">   
                
            </section>
        </div> -->


        
        <!-- <div class="col-12 col-md-3 pl-md-0">
            <section class="blockElement blockTwo whiteBG backgroundImage between-footer">
                <div class="row align-items-center">
                    <div class="col-12 text-center">
                        <div class="main-title">
                            <h3>Apply for <span>MAM/PAMM</span> account</h3>
                        </div>
                    </div>
                </div>
                <div class="row mt-3 justify-content-center">
                    <div class="col-12 col-lg-12">
                        <div class="row"> 
                            <div class="text-left col-12"></div>
                            <div class="col-12 col-md-12 mb-md-2">
                                <div class="form-group field-wrapper">
                                    <input placeholder="Email Address" type="email" name="username" class="float-field pt-0">
                                </div>
                            </div>
                            <div class="col-12 col-md-12 mb-md-2">
                                <div class="form-group field-wrapper">
                                    <input placeholder="Password" type="password" name="username" class="float-field  pt-0">
                                </div>
                            </div>
                            <div class="col-12 col-md-12">
                                <div class="form-group field-wrapper">
                                    <input placeholder="Confirm Password" type="password" name="username" class="float-field pt-0">
                                </div>
                            </div>
                            <div class="col-12 col-md-12">
                                <div class="form-group field-wrapper floating-label">
                                    <select class="float-field floating-select pt-0">
                                        <option value="">Select Residence Country</option>
                                        <option value="Afghanistan">Afghanistan</option>
                                        <option value="Åland Islands">Åland Islands</option>
                                        <option value="Albania">Albania</option>
                                        <option value="Algeria">Algeria</option>
                                        <option value="American Samoa">American Samoa</option>
                                        <option value="Andorra">Andorra</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div class="col-12 col-md-12 mt-3">
                                <div class="form-group field-wrapper text-center">
                                    <button class="prism_btn greenBG">Register</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div> -->
        

        
        
    </div>
</template>
<script>
    export default {
        name: 'mam-pamm',
        data() {
            return {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/socialTrade/pages/mam_pamm.vue